import React from "react";
import Select from "react-select";
import { Tooltip, Typography, Zoom } from "@mui/material";
import { Info } from "@mui/icons-material";
import { channelTip } from "../../../services/FieldsTips";

import "./index.css";
import Label from "../Label";

export default function ChannelSelect(props) {
  const { channels, handleSelectChannel } = props;

  const handleChangeChannel = (selectedChannel) => {
    const previousSelected = channels.find((c) => c.selected);
    if (previousSelected) {
      previousSelected.selected = false;
    }

    selectedChannel.selected = true;
    handleSelectChannel(selectedChannel);
  };

  const getLabel = (channel) => {
    return channel.selected
      ? labelWhenSelected(channel)
      : labelWhenNotSelected(channel);
  };

  const labelWhenNotSelected = (channel) => {
    return (
      <div className="channel-select-option-container">
        <span
          key={channel.value}
          value={channel.value}
          className="channel-select-option-value"
        >
          {channel.name}
        </span>
        <Tooltip
          title={
            <>
              <Typography>{channel.description.title}</Typography>
              {channel.description.detail}
            </>
          }
          placement="right"
          arrow
          TransitionComponent={Zoom}
        >
          <Info sx={{ fontSize: 15 }} />
        </Tooltip>
      </div>
    );
  };

  const labelWhenSelected = (channel) => {
    return (
      <span
        key={channel.value}
        value={channel.value}
        className="channel-select-option-value"
      >
        {channel.name}
      </span>
    );
  };

  return (
    <div className="channel-select-container">
      <div className="channel-label-container">
        <Label name="Canal" tip={channelTip} />
      </div>
      <Select
        placeholder="Canal"
        getOptionLabel={(option) => getLabel(option)}
        onChange={handleChangeChannel}
        options={[...channels]}
      />
    </div>
  );
}
